import { useConfirmDisciplineApi } from '@composables/api/classroom/confirm-discipline.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(async (to) => {
  const confirmBookingId = Number(to.query.confirm_booking_id)
  if (!confirmBookingId) return

  const { confirmDiscipline } = useConfirmDisciplineApi()

  await confirmDiscipline(confirmBookingId)
})